export enum MixPanelEventEnum {
    LogIn = 0,
    Bid = 1,
    Buy = 2,
    CPlate = 3,
    UPlate = 4,
    LicensePlateNotFound = 5,
    FirstAccessOfTheDay = 6
}
